// extracted by mini-css-extract-plugin
export default {"price":"f5-z","onSale":"g5-z","msrpLabelPrice":"h5-z","msrpLabel":"i5-z","originalPrice":"j5-z","percentOff":"k5-z"};